import { Box, Flex, Input, InputGroup, InputLeftAddon, InputRightAddon, Text, useToast } from '@chakra-ui/react'
import React from 'react'
import { HeaderCard } from './components/HeaderCard'
import { FaNewspaper } from 'react-icons/fa'
import { Card } from './components/Card'
import { Button } from './components/Button'
import { RoundedNumber } from './components/RoundedNumber'
import { Propostas as PropostasComponent } from './components/Propostas'
import { useNavigate } from 'react-router-dom'
import { useMutation } from 'react-query'
import { api } from '../../services/api'
import { user } from '../../helpers/user'
import { Button as InnoButton } from '../../components/Button'

async function propostaIsValid({ numeroProposta, codigoVendedor }) {
    const response = await api.get(`/site/v2/orcamento-crm/busca-proposta-vendedor`, {
        params: {
            numero_nota: numeroProposta,
            codigo_vendedor: codigoVendedor,
        },
    })

    const { valida_proposta, numero_nota: numeroNota } = response.data

    return {
        isValid: valida_proposta,
        numeroNota: numeroNota,
    }
}

async function abrirNovoOrcamento({ codigo_vendedor }) {
    const response = await api.post('/site/v2/orcamento-crm/inserir-orcamento', {
        codigo_vendedor,
    })

    return response.data
}

export const Propostas = ({ infoCustomer, codCustomerSelected, isLoading }) => {
    const navigate = useNavigate()

    const inputRef = React.useRef(null)

    const toast = useToast({
        position: 'top-right',
        duration: 3000,
        isClosable: true,
    })

    const { mutateAsync, isLoading: loading } = useMutation({
        mutationFn: abrirNovoOrcamento,
        onSuccess: (data) => {
            toast({
                title: `Orçamento aberto com sucesso, número do orçamento: ${data.numero_nota}`,
                status: 'success',
            })

            navigate(`/vendas/orcamento-pedido/${data.numero_nota}`)
        },
        onError: (error) => {
            toast({
                title: 'Erro ao abrir orçamento',
                description: error.message,
                status: 'error',
            })
        },
    })

    async function handleAbrirOrcamento() {
        await mutateAsync({ codigo_vendedor: user.codigo_vendedor })
    }

    async function onSubmit(e) {
        e.preventDefault()

        try {
            const value = inputRef.current.value

            if (!value) return toast({ description: 'Informe o número da proposta' })

            const { numeroNota } = await propostaIsValid({
                numeroProposta: inputRef.current.value,
                codigoVendedor: user.codigo_vendedor,
            })

            if (!numeroNota) return toast({ description: 'Proposta não encontrada' })

            navigate(`/vendas/orcamento-pedido/${numeroNota}`)
        } catch (error) {
            toast({ description: 'Proposta não encontrada' })
        }
    }

    return (
        <Box w="782px" alignSelf="start">
            <HeaderCard title="Propostas" icon={<FaNewspaper size={24} color="#2D2D2D" />} />
            <Card pt={'37px'} pb={'23px'} mt={2} isLoading={isLoading}>
                <Flex flexDir="column" gap={6}>
                    <Flex justifyContent="space-between" alignItems="center" mb={5}>
                        <InputGroup maxW="450px" as="form" onSubmit={onSubmit}>
                            <InputLeftAddon borderRadius="0" children="Buscar Proposta/Pedido" fontSize="12px" />
                            <Input borderRadius="0" ref={inputRef} placeholder="digite o número do pedido" _placeholder={{ fontSize: '12px' }} />
                            <InputRightAddon borderRadius="0" px={0}>
                                <InnoButton type="submit" colorScheme="blue" h="full" px={8} fontSize="12px">
                                    Buscar
                                </InnoButton>
                            </InputRightAddon>
                        </InputGroup>
                        <Button maxW="210px" w="100%" alignSelf="flex-end" onClick={handleAbrirOrcamento} isLoading={loading} loadingText="Abrindo...">
                            Nova Proposta
                        </Button>
                    </Flex>

                    <Flex alignItems="center" justifyContent="space-between">
                        <Flex flexDir="column" gap={2} alignItems="center">
                            <Text fontSize="12px" color="#2d2d2d" textTransform="uppercase" fontWeight="semibold">
                                Importantes
                            </Text>
                            <RoundedNumber number={infoCustomer?.propostas_importantes} color="white" bgColor="#95C620" to={`/propostas/${codCustomerSelected}?proposta_especial=true`} />
                        </Flex>
                        <Flex flexDir="column" gap={2} alignItems="center">
                            <Text fontSize="12px" color="#2d2d2d" textTransform="uppercase" fontWeight="semibold">
                                Não enviadas
                            </Text>
                            <RoundedNumber number={infoCustomer?.propostas_nao_enviadas} color="white" bgColor="#F11900" to={`/propostas/${codCustomerSelected}?propostas_nao_enviadas=s`} />
                        </Flex>
                        <Flex flexDir="column" gap={2} alignItems="center">
                            <Text fontSize="12px" color="#2d2d2d" textTransform="uppercase" fontWeight="semibold" transform="translateY(-10px)">
                                confecções
                            </Text>
                            <RoundedNumber
                                number={infoCustomer?.propostas_confeccoes}
                                color="#378BBF"
                                bgColor="#F5F5F5"
                                w="47px"
                                h="47px"
                                fontSize="23px"
                                to={`/propostas/${codCustomerSelected}?propostas_confeccoes=s`}
                            />
                        </Flex>
                        <Flex flexDir="column" gap={2} alignItems="center" transform="translateY(-10px)">
                            <Text fontSize="12px" color="#2d2d2d" textTransform="uppercase" fontWeight="semibold" textAlign="center">
                                confecções <br /> não respondidas
                            </Text>
                            <RoundedNumber
                                number={infoCustomer?.propostas_confeccoes_nao_resp}
                                color="#378BBF"
                                bgColor="#F5F5F5"
                                w="47px"
                                h="47px"
                                fontSize="23px"
                                to={`/propostas-de-confeccoes-nao-respondidas?v=${codCustomerSelected}`}
                            />
                        </Flex>
                        <Flex flexDir="column" gap={2} alignItems="center">
                            <Text fontSize="12px" color="#2d2d2d" textTransform="uppercase" fontWeight="semibold" transform="translateY(-10px)">
                                acompanhamento
                            </Text>
                            <RoundedNumber
                                number={infoCustomer?.acompanhamento_proposta}
                                color="#378BBF"
                                bgColor="#F5F5F5"
                                w="47px"
                                h="47px"
                                fontSize="23px"
                                to={`/propostas/${codCustomerSelected}?acompanhamento_proposta=s`}
                            />
                        </Flex>
                        <Flex flexDir="column" gap={2} alignItems="center">
                            <Text fontSize="12px" color="#2d2d2d" textTransform="uppercase" fontWeight="semibold" transform="translateY(-10px)">
                                perdidas
                            </Text>
                            <RoundedNumber
                                number={infoCustomer?.propostas_perdidas}
                                color="#378BBF"
                                bgColor="#F5F5F5"
                                w="47px"
                                h="47px"
                                fontSize="23px"
                                to={`/propostas/${codCustomerSelected}?propostas_perdidas=s`}
                            />
                        </Flex>
                    </Flex>
                    <Flex justifyContent="space-between" mt={5} px={3}>
                        <PropostasComponent valor={1} text="De até" lineColor="#AE86BC" to={`/propostas/${codCustomerSelected}?valor_verba=1`} />
                        <PropostasComponent valor={5} text="De até" lineColor="#F1606E" to={`/propostas/${codCustomerSelected}?valor_verba=2`} />
                        <PropostasComponent valor={10} text="De até" lineColor="#FFA200" to={`/propostas/${codCustomerSelected}?valor_verba=3`} />
                        <PropostasComponent valor={30} text="De até" lineColor="#AED47D" to={`/propostas/${codCustomerSelected}?valor_verba=4`} />
                        <PropostasComponent valor={30} text="Acima de" lineColor="#00B9AF" to={`/propostas/${codCustomerSelected}?valor_verba=5`} />
                    </Flex>
                </Flex>
            </Card>
        </Box>
    )
}
